import React, { useCallback, useState } from 'react';
import { LFC } from '../../Legacy';
import { Button, usePrompt } from '../../ui';
import { Copy, Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { TeamLocationSelectView } from './TeamLocationSelectView';

export type TeamSelectPopupArgs = {
    label: string,
    primary: string,
};

export const teamSelectPopup = (args: TeamSelectPopupArgs) => ({ ui: TeamSelectPopup, args });

export const TeamSelectPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const { label, primary } = args as TeamSelectPopupArgs;

    const [result, setResult] = useState<{ workspaceId: string, folderId?: string } | null>(null);

    const onAction = useCallback((confirm: boolean) => {
        if (confirm && result) {
            action(result);
        }
        else {
            dismiss();
        }
    }, [result]);

    const promptRef = usePrompt({ onAction });

    return <Popup ref={promptRef} w={32}>
        <Popup.Close onAction={() => onAction(false)} />
        <Popup.Title>Select a team or folder</Popup.Title>
        <Popup.Content>
            <Copy>
                {label}
            </Copy>
            <Spacer />
            <TeamLocationSelectView
                mode="user"
                onChange={setResult}
            />
            <Spacer />
        </Popup.Content>
        <Popup.Actions>
            <Button disabled={!result} variant="primary" onAction={() => onAction(true)}>
                {primary}
            </Button>
            <Button onAction={dismiss}>
                Cancel
            </Button>
        </Popup.Actions>
    </Popup>;
};
